module.exports = __webpack_public_path__ + "img/197.90f6cf2f.jpg";